import {IS_RUNNING_LOCALLY} from '@shared/env';
import {errorAsString} from '@shared/lib/utils/type_utils';

import {showAlert} from '@shared_web/components/core/notifications';

interface NotifyErrorOptions {
  extra?: unknown;
  message?: string;
  duration?: number;
  silent?: boolean;
}

export function notifyError(err: unknown, options: NotifyErrorOptions = {}): void {
  const {extra, message, duration, silent} = options;
  const errStr = errorAsString(err);
  const msgStr = message ?? errStr;
  if (!silent) {
    let alertStr = msgStr;
    if (IS_RUNNING_LOCALLY && msgStr !== errStr) {
      alertStr = `${msgStr} (${errStr})`;
    }
    showAlert(alertStr, {duration});
  }

  // // TODO: Send to the sourcemap server to convert the error stack and log to s3
  // // eslint-disable-next-line no-console
  // console.error('Should send error log to backend', errorJson);

  console.error(err);
  if (extra !== undefined) {
    console.log(extra);
  }
}
